import { useEffect } from 'react';
import Box from '@mui/material/Box';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import './assign-divisions-modal.scss';
import { TouchableOpacity, View } from '../../../../common';
import {
  CommonButton,
  Divider,
  EndListView,
  SpinnerLoader,
} from '../../../../components';
import {
  getDivisionsByCfaId,
  SelectedCfa,
  useAppSelector,
} from '@zonofi/zono-money-store';
import { SVGS } from '../../../../assets';
import { useAddDivisions } from '../../hooks/use-add-division';

interface AssignDivisionModalProps {
  open: boolean;
  onClose: () => void;
  currentSelectedCfa?: SelectedCfa;
}

export const AssignDivisionModal: React.FC<AssignDivisionModalProps> = ({
  open,
  onClose,
  currentSelectedCfa,
}) => {
  const divisionByCfa = useAppSelector((state) =>
    getDivisionsByCfaId(state, currentSelectedCfa?.id)
  );

  const {
    onSelectAllPress,
    onAssignDivisionsPress,
    onDivisionPress,
    divisionsData,
    lastItemRef,
    onScroll,
    isEndOfList,
    setSelectedDivisionIds,
    selectedDivisionIds,
  } = useAddDivisions({
    onClose,
    currentSelectedCfa,
  });

  useEffect(() => {
    if (!open) return;
    setSelectedDivisionIds(divisionByCfa ?? []);
  }, [open, currentSelectedCfa?.id]);

  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={onClose}
      onOpen={() => {}}
      disableSwipeToOpen
      PaperProps={{
        className: 'division-modal__drawer',
        style: { height: '90vh' },
      }}
    >
      <Box className="division-modal__container">
        <div className="division-modal__header">
          <TouchableOpacity onPress={onClose}>
            <div className="division-modal__header--text close-button font-semibold">
              {'Close'}
            </div>
          </TouchableOpacity>
          <div className="division-modal__header--text font-semibold">
            {'Select Divisions'}
          </div>
          <TouchableOpacity onPress={onSelectAllPress}>
            <div className="division-modal__header--text select-button font-semibold">
              {'Select all'}
            </div>
          </TouchableOpacity>
        </div>
        <Divider />

        <View className="division-list__container" onScroll={onScroll}>
          {divisionsData && divisionsData.length > 0 && (
            <div className="division-list__container--header font-semibold">{`${divisionsData.length} Division`}</div>
          )}

          <div className="division-list__view">
            {divisionsData.map((division) => {
              const isSelected = selectedDivisionIds.some(
                (d) => d.id === division.id
              );

              return (
                <TouchableOpacity
                  key={division?.id}
                  className="division-list__view--items"
                  onPress={() => onDivisionPress(division)}
                >
                  <img
                    src={isSelected ? SVGS.CheckboxBlack : SVGS.UncheckedBox}
                  />
                  <div className="division-list__view--division-text font-semibold">
                    {division.name}
                  </div>
                </TouchableOpacity>
              );
            })}
            <div ref={lastItemRef} />
            {!isEndOfList && <SpinnerLoader />}
            {isEndOfList && <EndListView />}
          </div>
        </View>
        <div className="division-list__footer">
          <CommonButton
            text={
              selectedDivisionIds?.length > 0
                ? `Assign ${selectedDivisionIds?.length} Divisions`
                : 'Assign Divisions'
            }
            onPress={onAssignDivisionsPress}
            disabled={selectedDivisionIds?.length === 0}
          />
        </div>
      </Box>
    </SwipeableDrawer>
  );
};
